import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { CustomButton } from '../../../_common';
import sentemail from '../../../../assets/sentemail.png';
import './SendEmailModal.scss';
interface ConfirmDispatchModalProps {
    onClickHide: () => void;
    show: boolean;
    textMessage: string;
}

const SendEmailModal = ({ show, onClickHide, textMessage }: ConfirmDispatchModalProps): React.ReactElement => {
    return (
        <Modal show={show} onHide={onClickHide} backdrop="static">
            <Modal.Header className="ConfirmDispatchModal-Header">
                <Modal.Title className="ConfirmDispatchModal-Header-Container">
                    <i className="material-icons ConfirmDispatchModal-X-Button" onClick={onClickHide}>
                        close
                    </i>
                    <img className="ConfirmDispatchModal-Icon Email-Modal-Icon" src={sentemail} alt="dispatch icon" />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="ConfirmDispatchModal-Body Email-Modal-Body">{textMessage}</Modal.Body>
            <Modal.Footer className="ConfirmDispatchModal-Footer">
                <div style={{ width: '100 px' }}>
                    <CustomButton title="OK" isDisabled={false} onClick={onClickHide}></CustomButton>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default SendEmailModal;

